import {
  ENTRY_FEE_CHALLENGERS_S5,
  FIRST_PLACE_PRIZE_CHALLENGERS_S5,
  INITIAL_PURSE_CHALLENGERS_S5,
  MIN_PRIZE_CHALLENGERS_S5,
  PAID_PLACES_CHALLENGERS_S5,
  PRIZE_SCALING_CHALLENGERS_S5,
  SIDE_GAMES_CHALLENGERS_S5,
} from "../../constants";

export const prizeCalculatorChallengersS5 = (playersCount: number): number[] => {
  if (!Number.isSafeInteger(playersCount) || playersCount <= 0) return [];

  // The finance sheet always spreads the pool over PAID_PLACES (40) ranks,
  // even for smaller fields; ranks beyond the field are simply not paid.
  // Mirror that here so the site matches the sheet.
  const paidPlaces = PAID_PLACES_CHALLENGERS_S5;
  const table = new Array<number>(paidPlaces).fill(0);
  table[0] = FIRST_PLACE_PRIZE_CHALLENGERS_S5;

  const remainingPool =
    INITIAL_PURSE_CHALLENGERS_S5 +
    ENTRY_FEE_CHALLENGERS_S5 * playersCount -
    SIDE_GAMES_CHALLENGERS_S5 -
    FIRST_PLACE_PRIZE_CHALLENGERS_S5;
  const weightFor = (rank: number) =>
    (paidPlaces - rank + 1) *
    Math.max(1, 10 * Math.pow(1 - PRIZE_SCALING_CHALLENGERS_S5, rank - 2));

  let totalWeight = 0;
  for (let rank = 2; rank <= paidPlaces; rank++) {
    totalWeight += weightFor(rank);
  }

  // Ranks are kept unrounded until the end, as in the sheet.
  let awarded = 0;
  for (let rank = 3; rank <= paidPlaces; rank++) {
    const prize = Math.max(
      MIN_PRIZE_CHALLENGERS_S5,
      (weightFor(rank) / totalWeight) * remainingPool
    );
    table[rank - 1] = prize;
    awarded += prize;
  }

  // Second place absorbs minimum-prize adjustments.
  table[1] = Math.max(MIN_PRIZE_CHALLENGERS_S5, remainingPool - awarded);

  const prizes = new Array<number>(playersCount).fill(0);
  for (let i = 0; i < Math.min(playersCount, paidPlaces); i++) {
    prizes[i] = Math.round(table[i]);
  }
  return prizes;
};
